<div id="footer" class="footer" [ngClass]="{ mobilizesLogo: mobilizesLogo }">
	<div class="footer-container">
		<div class="footer-content" [ngClass]="{ 'align-items-center': isDealer }">
			@if (!mobilizesLogo) {
				<div class="col-4 desktop-item d-flex align-items-center">
					<p>Mobilize Lease&Co Colombia es la compañia del Grupo Renault para las nuevas formas de movilidad. El servicio de renting de Renault Colombia es prestado por Mobilize Lease&Co.</p>
				</div>
			}

			@if (mobilizesLogo) {
				<div class="footer-logo">
					<img width="220" height="50" src="/assets/images/mobilize-logo.svg" alt="" loading="lazy" />
				</div>
			}

			@if (!isDealer) {
				<div class="sitemap">
					<div class="footer-title">
						<p class="footer-title">{{ textFooter.siteMap }}</p>
					</div>
					<ul>
						<li>
							<a (click)="emitEvent('como-funciona-renta-renault')" [routerLink]="['/institucional/como-funciona-renta-renault']">{{ textFooter.howDoesItWork }}</a>
						</li>
						<li>
							<a (click)="emitEvent('faq-renta-de-carros')" [routerLink]="['/institucional/faq-renta-de-carros']">{{ textFooter.doubts }}</a>
						</li>
						<li>
							<a (click)="emitEvent('alquiler-de-carro-empresas')" [routerLink]="['/institucional/alquiler-de-carro-empresas']">{{ textFooter.forBusiness }}</a>
						</li>
						<li>
							<a (click)="emitEvent('faça-uma-simulacao')" [routerLink]="['/simulador']">{{ textFooter.runAsimulation }}</a>
						</li>
						<li>
							<a (click)="emitEvent('solicitar-asesoria')" [routerLink]="['/institucional/asesoria']">{{ textFooter.solicitarAsesoria }}</a>
						</li>
					</ul>
				</div>
			}
			@if (isDealer) {
				<div class="sitemap">
					<div class="attendance-dealer">
						{{ textFooter.serviceCenter }}
						<p class="phone">{{ footerData?.telefone_bloco_esquerda }}</p>
						<p class="phone">{{ emailToShow }}</p>
					</div>
					<div class="attendance-dealer">
						Línea de cobranza
						<p class="social">Fijo: {{ footerData?.telefone_Linea_cobranza }}</p>
						<p class="social">Whatsapp: {{ footerData?.whatsapp_Linea_cobranza }}</p>
						<p class="phone email">Correo: {{ footerData?.Email_Linea_cobranza }}</p>
					</div>
				</div>
			}
			<div class="attendance-content">
				@if (!isDealer) {
					<div class="footer-title attendance-title justify-content-center justify-content-md-start">
						<p class="footer-title">{{ textFooter.serviceCenter }}</p>
					</div>
				}
				<div class="attendance text-center text-md-start">
					@if (!isDealer) {
						<div class="phone">{{ footerData?.telefone_bloco_esquerda }}</div>
					}
					@if (!isDealer) {
						<div class="phone email">{{ emailToShow }}</div>
					}

					<div class="hours" [ngClass]="{ 'mb-0': isDealer }">
						<strong>{{ footerData?.titulo_bloco_esquerda }}</strong>
						<br />

						@if (footerData?.atendimento_bloco_esquerda; as firstPart) {
							<strong>
								{{ firstPart.split(' y ')[0] }}
							</strong>
						}
						<br />
						@if (footerData?.atendimento_bloco_esquerda; as secondPart) {
							<strong>
								{{ secondPart.split(' y ')[1] }}
							</strong>
						}

						<!-- {{ textFooter.operationWeekend }}<br /> -->
					</div>
				</div>
				@if (!isDealer) {
					<div class="footer-title attendance-title justify-content-center justify-content-md-start">
						<p class="footer-title">Línea de cobranza</p>
					</div>
				}
				<div class="attendance text-center text-md-start">
					@if (!isDealer) {
						<div class="social">Fijo: {{ footerData?.telefone_Linea_cobranza }}</div>
					}
					@if (!isDealer) {
						<div class="social">Whatsapp: {{ footerData?.whatsapp_Linea_cobranza }}</div>
					}
					@if (!isDealer) {
						<div class="phone email">Correo: {{ footerData?.Email_Linea_cobranza }}</div>
					}
				</div>
			</div>
			<div class="social-container">
				<!-- <div class="col-12 col-md-2 d-flex justify-content-md-end social-container"> -->
				<div class="social">
					<p class="footer-title" [ngClass]="{ 'mb-1': isDealer, 'mb-3': !isDealer }">
						{{ textFooter.socialNetworks }}
					</p>
					<ul class="social-items">
						<li>
							<a href="https://www.facebook.com/profile.php?id=61552668974116" target="_blank" rel="noopener noreferrer">
								<img width="31" height="31" src="/assets/icons/svg/facebook_cl.svg" alt="Renault Renting en Facebook" loading="lazy" />
							</a>
						</li>
						<li>
							<a href="https://instagram.com/mobilize_lease_co?igshid=OGQ5ZDc2ODk2ZA==" target="_blank" rel="noopener noreferrer">
								<img width="31" height="31" src="/assets/icons/svg/instagram_cl.svg" alt="Renault Renting en Instagram" loading="lazy" />
							</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="col-1 d-flex desktop-item">
				<div (click)="scrollTop()" class="scroll-top">
					<img src="/assets/icons/svg/arrow-up.svg" alt="Volver ao início" loading="lazy" />
					<p style="text-align: center; margin-top: 10px">{{ textFooter.backToTheStart }}</p>
				</div>
			</div>
		</div>
		<!-- <div class="row company-infos footer-content">
    <div class="col-12 col-md-6 address-info align-text-right">
      RCI Serviços & Participações Ltda - CNPJ 13.758.102/0001-12
    </div>
    <div class="col-12 col-md-6 address-info align-text-left">
      Rua Pasteur, 463 - Água Verde - CEP 80250-104 - Curitiba/PR
    </div>
  </div> -->
		<!-- <div class="row company-docs footer-content">
  <div class="d-flex justify-content-end col-12 col-md-6">
    <ul class="mb-0">
      <li class="mb-0">
        <a
          (click)="emitEvent('termos-de-uso')"
          target="_blank"
          rel="noopener noreferrer"
          href="{{ environment.imgUrl + footerData?.termos_de_uso }}"
          >
          {{textFooter.termsOfUse}}
        </a>
      </li>
      <li class="mb-0">
        <a
          (click)="emitEvent('politicas-de-cookie')"
          target="_blank"
          rel="noopener noreferrer"
          href="{{ environment.imgUrl + footerData?.politica_de_cookies }}"
          >
          {{textFooter.cookiePolices}}
        </a>
      </li>
      <li class="mb-0">
        <a
          (click)="emitEvent('politica-de-privacidade')"
          target="_blank"
          rel="noopener noreferrer"
          href="{{ environment.imgUrl + footerData?.politica_de_privacidade }}"
          >
          {{textFooter.privacyPolicy}}
        </a>
      </li>
    </ul>
  </div> -->
		<!-- <div class="col-12 col-md-6">
  <span class="copyrights"> © 2022 Renault OnDemand - v 3.0 Todos os direitos reservados </span>
</div> -->
		<!-- </div> -->

		<div class="company-docs">
			<ul class="mb-0">
				<li class="mb-0">
					<a (click)="emitEvent('termos-de-uso')" [routerLink]="'/institucional/termos-de-uso-del-sitio'" rel="noopener noreferrer">
						<!-- href="{{ environment.imgUrl + footerData?.termos_de_uso }}" -->
						{{ textFooter.termsOfUse }}
					</a>
				</li>
				<li class="mb-0">
					<a (click)="emitEvent('politica-de-cobranza')" [routerLink]="'/institucional/politica-de-cobranza'" rel="noopener noreferrer">
						<!-- href="{{ environment.imgUrl + footerData?.termos_de_uso }}" -->
						{{ textFooter.termsOfCollection }}
					</a>
				</li>
				<li class="mb-0">
					<a (click)="emitEvent('politicas-de-cookie')" [routerLink]="'/institucional/politica-de-cookies'" rel="noopener noreferrer">
						<!-- href="{{ environment.imgUrl + footerData?.politica_de_cookies }}" -->
						{{ textFooter.cookiePolices }}
					</a>
				</li>
				<li class="mb-0">
					<a (click)="emitEvent('politica-de-privacidad')" [routerLink]="'/institucional/politicas-de-privacidad-de-proteccion-de-datos-personales'" rel="noopener noreferrer">
						<!-- href="{{ environment.imgUrl + footerData?.politica_de_privacidade }}" -->
						{{ textFooter.privacyPolicy }}
					</a>
				</li>
			</ul>

			<!-- <div class="col-12 col-md-6">
  <span class="copyrights"> © 2022 Renault OnDemand - v 3.0 Todos os direitos reservados </span>
</div> -->
		</div>
		<div class="row footer-content mobile-item">
			<div class="col-12">
				<div (click)="scrollTop()" class="scroll-top text-center my-4">
					{{ textFooter.backToTheStart }}
					<img class="mx-2 mt-1" width="13" height="16" src="/assets/icons/svg/top-arrow-mobile.svg" alt="Volver ao início" loading="lazy" />
				</div>
			</div>
		</div>
	</div>
</div>
